export enum ContractBillingTypeEnum {
  /**
   * Billing based on a fixed rate
   */
  FLAT_RATE = "flat_rate",

  /**
   * Billing based on actual usage
   */
  MONTHLY = "monthly",

  /**
   * Billing based on actual usage
   */
  QUARTERLY = "quarterly",

  /**
   * Billing based on actual usage
   */
  SEMIANNUAL = "semiannual",

  /**
   * Billing based on actual usage
   */
  ANNUAL = "annual"
}
